import React, { useState, useRef, useEffect } from 'react';
import { useI18n, LANGS } from '@/contexts/I18nContext';
import { Globe } from 'lucide-react';

export default function LanguageSelector({ variant = 'default' }) {
  const { lang, setLang } = useI18n();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const current = LANGS.find(l => l.code === lang);

  return (
    <div ref={ref} className="relative" data-testid="language-selector">
      <button
        onClick={() => setOpen(!open)}
        className={`flex items-center gap-1.5 transition-all ${
          variant === 'minimal'
            ? 'text-xs font-medium text-manrique-grey hover:text-manrique-black px-2 py-1 rounded-lg hover:bg-white/50'
            : 'text-sm font-medium border border-black/10 rounded-full px-3 py-1.5 hover:bg-[#FBF8F3] text-manrique-grey'
        }`}
        data-testid="language-selector-button"
      >
        <Globe size={variant === 'minimal' ? 13 : 14} />
        <span>{current?.label}</span>
      </button>
      {open && (
        <div className="absolute right-0 top-full mt-1 bg-white rounded-xl border border-black/10 shadow-lg overflow-hidden z-50 min-w-[140px] animate-fade-in">
          {LANGS.map(l => (
            <button
              key={l.code}
              onClick={() => { setLang(l.code); setOpen(false); }}
              className={`w-full flex items-center gap-2 px-4 py-2.5 text-sm transition-colors ${
                lang === l.code
                  ? 'bg-[#48293A]/5 text-[#48293A] font-medium'
                  : 'text-manrique-grey hover:bg-[#FBF8F3]'
              }`}
              data-testid={`lang-option-${l.code}`}
            >
              <span className="font-bold text-xs w-6">{l.label}</span>
              <span>{l.name}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
